module.exports = new __parcel__URL__("snow-projections-median.358ebb24.jpg").toString();